import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
ReactDOM.render(React.createElement(App, null), document.getElementById('root'));
if (navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (var _i = 0, registrations_1 = registrations; _i < registrations_1.length; _i++) {
            var registration = registrations_1[_i];
            registration.unregister();
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 13
// module chunks = 0